// extracted by mini-css-extract-plugin
module.exports = {"root":"UIploadProgress_root__KRovo","rotate":"UIploadProgress_rotate__1sgR_"};